import { render, staticRenderFns } from "./CloseClaimManagementButton.vue?vue&type=template&id=f8ee7a18&scoped=true"
import script from "./CloseClaimManagementButton.vue?vue&type=script&lang=ts"
export * from "./CloseClaimManagementButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ee7a18",
  null
  
)

export default component.exports